import { Component, input, OnInit } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import type { WorkflowDiffVersionType } from "../../../../../../models";
import { AttachmentDiffViewComponent, NormalDiffViewComponent } from "../../_lib";
import { AccordionSectionConfigType, ScreenSectionConfigType, ScreenType } from "../../wf-difference.types";
import { dataEntryInfoScreenConfig } from "./data-entry-info-screen-config";

@Component({
  selector: "adaa-data-entry-info-screen",
  imports: [TranslatePipe, NormalDiffViewComponent, AttachmentDiffViewComponent],
  templateUrl: "./data-entry-info-screen.html",
  styleUrl: "./data-entry-info-screen.scss",
})
export class DataEntryInfoScreenComponent implements OnInit {
  showOnlyNew = input.required<boolean>();
  isNew = input<boolean>(false);
  newObject = input<WorkflowDiffVersionType>();
  oldObject = input<WorkflowDiffVersionType>();
  viewOnlyDifferences = input<boolean>(false);

  config: {
    type: ScreenType;
    sections: (ScreenSectionConfigType | AccordionSectionConfigType)[];
  };

  public ngOnInit(): void {
    this.config = dataEntryInfoScreenConfig;
  }
}
